/**
 * Check if a coordinate center [lat, lng] is a valid, finite pair.
 * Canonical source — import from here, not from mapViewUtils or elsewhere.
 */
export function isValidCenter(center) {
  return (
    center != null
    && Array.isArray(center)
    && center.length >= 2
    && Number.isFinite(center[0])
    && Number.isFinite(center[1])
  );
}
